import { render, staticRenderFns } from "./promotionMaterial.vue?vue&type=template&id=46faec1a&scoped=true"
import script from "./promotionMaterial.vue?vue&type=script&lang=js"
export * from "./promotionMaterial.vue?vue&type=script&lang=js"
import style0 from "./promotionMaterial.vue?vue&type=style&index=0&id=46faec1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46faec1a",
  null
  
)

export default component.exports